import { DataTagType } from "@hellocashflow/domain";

import type { NumberFormatType } from "./insertFormulaTypes";

export const insertFormulaDataTagKeys = Object.keys(DataTagType).filter((key) =>
  Number.isNaN(Number(key)),
);

export const appendFormulaTag = (
  formulaText: string,
  selectedTag: string,
): string => {
  const spacer = formulaText.length > 0 ? " " : "";
  return `${formulaText}${spacer}[${selectedTag}] `;
};

export const getNextNumberFormatFromFormulaKey = (
  key: string,
  formulaText: string,
  currentNumberFormat: NumberFormatType,
): NumberFormatType => {
  if (key === "/") {
    return "percent";
  }

  if (key === "?") {
    return "text";
  }

  if ((key === "Backspace" || key === "Delete") && !formulaText.includes("/")) {
    return "currency";
  }

  return currentNumberFormat;
};
